(function(app) {

    app.service("calendarsService", ["moment", function(moment) {

        this.getYahooCalendarUrl = function (data) {
            var url = "http://calendar.yahoo.com/?v=60&view=d&type=20";
            var duration = getHoursDuration(data.startDate, data.endDate);

            url += "&TITLE=" + data.title;
            url += "&ST=" + data.startDate + "&DUR=" + duration;
            url += "&DESC=" + data.description;
            url += "&in_loc" + data.location;

            return url;
        };

        this.getMicrosoftCalendarUrl = function (data) {
            var url = "http://calendar.live.com/calendar/calendar.aspx?rru=addevent";

            url += "&summary=" + data.title;
            url += "&dtstart=" + data.startDate + "&dtend=" + data.endDate;
            url += "&description=" + data.description;
            url += "&location=" + data.location;

            return url;
        };

        this.getGoogleCalendarUrl = function (data) {
            var url = "https://www.google.com/calendar/render?action=TEMPLATE";

            url += "&text=" + data.title;
            url += "&dates=" + data.startDate + "/" + data.endDate;
            url += "&details=" + data.description;
            url += "&location=" + data.location;

            return url;
        };

        this.getIcsCalendar = function (data) {
            const cal = [
                "BEGIN:VCALENDAR",
                "VERSION:2.0",
                "BEGIN:VEVENT",
                "CLASS:PUBLIC",
                "DESCRIPTION:" + formatIcsText2(data.description, 5000),
                "DTSTART:" + data.startDate,
                "DTEND:" + data.endDate,
                "LOCATION:" + formatIcsText(data.location, 64),
                "SUMMARY:" + formatIcsText(data.title, 66),
                "TRANSP:TRANSPARENT",
                "END:VEVENT",
                "END:VCALENDAR",
                "UID:" + Math.random().toString(36).substr(2),
                "DTSTAMP:" + moment().format("YYYYMMDDTHHmmss"),
                "PRODID:ForceCRM"
            ].join("\n");
            return cal;
        };


        function getHoursDuration(startDate, endDate) {
            var start = moment(new Date(startDate));
            var end = moment(new Date(endDate));

            var hours = moment.duration(end.diff(start)).asHours();

            return getMilitaryHours(hours);
        }

        function getMilitaryHours(hours) {
            if (hours % 1 === 0.5) {
                return Math.floor(hours) + "30";
            }
            return Math.floor(hours) + "00";
        }

        function formatIcsText(str, maxLength) {
            if (!str) return "";

            str = str.replace(/\n/g, ". "); // str = str.replace(/\n/g, "//n"); <- WHY WON"T YOU WORK!!!
            str = str.substring(0, maxLength);

            return str;
        }

        //using this for ICS description for now. Will merge with original function once it's stable enough
        function formatIcsText2(str, maxLength) {
            if (!str) return "";

            str = str.replace(/\n/g, ".\\n"); // str = str.replace(/\n/g, "//n"); <- WHY WON"T YOU WORK!!! <<- So it needs to be double backslash & also Outlook/iOS needs a period before the \n to respect the line-break dont ask why
            str = str.substring(0, maxLength);

            return str;
        }

    }]);

})(window.app); //jshint ignore:line